// Google Analytics page view tracking hook
import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { initGA, trackPageView } from '../lib/analytics';

export const useAnalytics = () => {
  const [location] = useLocation();
  useEffect(() => {
    initGA();
    trackPageView(location);
  }, [location]);
};
